export function loadGoogleCaptcha() {
  const captchaUrl = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.VUE_APP_GOOGLE_RECAPTCHA_CLIENT_KEY}`;

  const recaptchaScript = document.createElement('script');
  recaptchaScript.setAttribute('id', 'gcaptcha');
  recaptchaScript.setAttribute('src', captchaUrl);
  document.head.appendChild(recaptchaScript);
}

export function unloadGoogleCaptcha() {
  const recaptchaScript = document.getElementById('gcaptcha');
  document.head.removeChild(recaptchaScript);

  const recaptchaElems = document.getElementsByClassName('grecaptcha-badge');
  if (recaptchaElems.length) {
    recaptchaElems[0].remove();
  }
}

export async function getRecaptchaToken(action) {
  return new Promise(resolve => {
    /* global grecaptcha */
    grecaptcha.enterprise.ready(async () => {
      const token = await grecaptcha.enterprise.execute(
        process.env.VUE_APP_GOOGLE_RECAPTCHA_CLIENT_KEY,
        { action }
      );
      resolve(token);
    });
  });
}
